<template>
    <div class="main-body">
        <div class="header">
            消费用户订单报表
        </div>
        <div class="out">
            <div class="search2">

                <div style="float:right">
                    <elSelectTree :options='zoneValue' accordion :props="zoneProps" placeholder="请选择所属区域"
                                  v-on:getZoneValue="getZoneValue" style="width:150px;margin-right:10px"></elSelectTree>
                    <el-date-picker size="mini"
                        ref="picker"
                        v-model="datetimerangeValue"
                        type="daterange"
                        :clearable='false'
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="width:250px;margin-right:10px">
                    </el-date-picker>
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                </div>

                <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" v-loading="loading" :data="tableData" :height="th" border style="width: 100%;">
                <el-table-column prop="totalMoney" fixed="left" label="订单金额" width="140"></el-table-column>
                <el-table-column prop="abolishMoney" label="取消金额" width="120"></el-table-column>
                <el-table-column prop="orderCount" label="订单数" width="120"></el-table-column>
                <el-table-column prop="noOrder" label="未接单" width="200"></el-table-column>
                <el-table-column prop="yesOrder" label="已接单"></el-table-column>
                <el-table-column prop="startServe" label="开始服务" width="120"></el-table-column>
                <el-table-column prop="successOrder" label="订单完成" width="120"></el-table-column>
                <el-table-column prop="schonAppraise" label="已评价" width="120"></el-table-column>
                <el-table-column prop="totalAbolish" label="取消订单" width="200"></el-table-column>
            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            :current-page.sync="currentPage"  @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>


        </div>

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import elSelectTree from "../../../components/ElSelectTree"
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,

                showModalAdd:false,
                showModalEdit:false,
                datetimerangeValue:'',
                tableData:null,
                zoneValue:[],
                idNumber:'',
                zoneCode:'',
                phone:'',
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',
                zoneProps:{
                    emitPath:false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
            }
        },
        components:{
            elSelectTree
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){
                const end = new Date();
                const start=new Date(end - 1000 * 60 * 60 * 24 * 365);
                this.datetimerangeValue=[start, end];
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Zone/ListForStaff",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        var data=JSON.stringify(response.data.data);
                        data=JSON.parse(data.replace(/"listZoneDTO":\[\],/g,''))
                        this.zoneValue = data;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                })
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            searchGetList(){
                this.getList();
            },
            getZoneValue(val){
                this.zoneCode=val
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1

                var zoneCode='00000000-0000-0000-0000-000000000000'
                if(this.zoneCode){
                    zoneCode=this.zoneCode
                }

                let that = this;
                that.loading = true;

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Order/GetOrderInfo",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                        startTime:timefilters(this.datetimerangeValue[0]).substring(0,10),
                        endTime:timefilters(this.datetimerangeValue[1]).substring(0,10),
                        zoneCode:zoneCode
                    }
                }).then( (response)=> {
                    //console.log(response);
                  that.loading = false;

                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                  that.loading = false;
                    console.log(error);
                });
            },
            applyTypeTitle(row){
                if(row.applyType == 0){
                    return "80-99周岁";
                }
                if(row.applyType == 1){
                    return "100周岁及以上";
                }
            },
            genderTitle(row, column, cellValue){
                if(cellValue == 0){
                    return "女";
                }
                if(cellValue == 1){
                    return "男";
                }
            },



        }
    }
</script>

<style scoped>

</style>
